<template>
  <div class="email-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text"
          :id="options.name"
          :value="options.value"
          :name="options.name"
          @input="validate($event.target.value)"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'EmailInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: ''
        }
      }
    }
  },
  computed: {
    validationIcon,
    validationClass,
    validationMessage,
    invalidMessage () {
      if (!this.isRegex) {
        return 'Please enter a valid email address'
      } else {
        return this.options.label + ' is required'
      }
    }
  },
  data () {
    return {
      isRegex: true,
      isDirty: false,
      isValid: false,
      regex: /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/
    }
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/EmailInput.vue